// Customer Portal Supabase Client - SINGLE SOURCE OF TRUTH
// All services in the customer portal should use this client

import { createClient } from '@supabase/supabase-js';
import { createResilientFetch } from '@tradesmatepro/shared-ui/utils/resilientFetch';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from './env';
import { report } from './errorReporter';

// Single Supabase client for the entire customer portal
//
// Connection problems: time out and retry (PRODUCT_DECISIONS, 2026-10-23). Same policy as
// the contractor app (packages/shared-ui/utils/resilientFetch.js): every call times out
// instead of waiting forever, reads retry twice, writes (approvals, payments) never retry.
// Exported for the few calls that build their own request to a Supabase URL (edge functions
// called with a hand-made Authorization header): they get the same timeouts and rules.
export const resilientFetch = createResilientFetch({ supabaseUrl: SUPABASE_URL, report });

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'customer-portal-auth', // Single consistent storage key
  },
  global: { fetch: resilientFetch },
});

// Unauthenticated Supabase client for realtime subscriptions
// Portal uses custom token auth, not Supabase auth
// This client has NO auth session, so RLS policies must validate via portal_token
export const supabaseRealtime = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

// Legacy function for backward compatibility
export function getSupabaseClient() {
  return supabase;
}
